import moment from 'moment';

export function patientName(request) {
    const person = request && (request.person || request.patient);

    if (!person) {
        return 'Unknown';
    }

    if (person.first_name && person.last_name) {
        return `${person.first_name} ${person.last_name}`.trim();
    }

    if (person.name) {
        return person.name;
    }

    if (person.email) {
        return person.email;
    }

    return 'Unknown';
}

export function statusClass(status) {
    if (!status) {
        return 'rr-status-pending';
    }

    return `rr-status-${String(status).toLowerCase()}`;
}

export function localTime(datetime, format = 'M/D/YYYY, h:mm A') {
    if (!datetime) {
        return 'Unknown date';
    }

    let value = datetime;

    if (typeof value === 'object' && value.date) {
        value = value.date;
    }

    value = String(value).replace(/\.000000/, '');

    const utcDate = moment.utc(value);

    if (!utcDate.isValid()) {
        return 'Unknown date';
    }

    return moment(utcDate).local().calendar('', { sameElse: format });
}

export function apiMessage(error, fallback) {
    const response = error && error.response;
    const data = response && response.data;

    if (data && data.message) {
        return data.message;
    }

    if (data && data.errors) {
        const first = Object.keys(data.errors)[0];

        if (first && data.errors[first] && data.errors[first].length) {
            return data.errors[first][0];
        }
    }

    return fallback;
}



// WEBPACK FOOTER //
// ./resources/assets/js/resumeRequestHelpers.js